export default function BlogCTA() {
  return (
    <section className="py-20 bg-gradient-to-br from-slate-50 to-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="bg-gradient-to-br from-teal-500 to-teal-600 rounded-3xl p-12 shadow-2xl">
          <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <i className="ri-mail-line text-4xl text-white"></i>
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Ready to Start Your Project?
          </h2>
          
          <p className="text-xl text-teal-50 mb-8 max-w-2xl mx-auto">
            Get professional AutoCAD formwork drawings and Bluebeam takeoffs for your next construction project. Free quote in 24-48 hours.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/home#contact"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-teal-600 font-semibold rounded-lg hover:bg-teal-50 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-message-3-line mr-2"></i>
              Get a Free Quote
            </a>
            <a 
              href="/home#services"
              className="inline-flex items-center justify-center px-8 py-4 bg-teal-700 text-white font-semibold rounded-lg hover:bg-teal-800 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-service-line mr-2"></i>
              View Our Services
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
